<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3
            class="page-title"
            v-if="!isCapacityFull && !isError && !isSuccess"
          >
            {{ $route.params.id ? "Edit " : "Add " }}Class Booking
          </h3>
          <h3 class="page-title" v-else>
            <template v-if="isSuccess">
              <i
                class="far fa-circle-check"
                style="color: #55ce63; font-size: 30px"
              ></i>
              <span class="text-success">Successful Class Booking</span>
            </template>
            <template v-else>
              <i
                class="far fa-times-circle"
                style="color: #f62d51; font-size: 30px"
              ></i>
              <span v-if="isCapacityFull" class="text-danger">
                Class Capacity is Full
              </span>
              <span v-else-if="isError" class="text-danger">
                Something Went Wrong
              </span>
            </template>
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form
      @submit.prevent="next"
      v-if="page == 1 && !isCapacityFull && !isError && !isSuccess"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <!-- School -->
              <div
                class="form-row"
                v-if="tokenObj.UserType == userTypeMainAdmin"
              >
                <div class="form-group col-md-6">
                  <label>School<span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="schoolId"
                    required
                    @change="onChangeSchool($event)"
                  >
                    <option value>-- Please Select School --</option>
                    <option
                      v-for="item in schools"
                      :value="item.Id"
                      :key="item.Id"
                    >
                      {{ item.Name }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- /School -->

              <!-- Student and Email -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Student<span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="studentId"
                    required
                    @change="onChangeStudent($event)"
                    :disabled="isStudent"
                  >
                    <option value>-- Please Select Student --</option>
                    <option
                      v-for="item in students"
                      :value="item.Id"
                      :key="item.Id"
                    >
                      {{ item.Name }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-6">
                  <label>Email<span class="text-danger">*</span></label>
                  <input
                    readonly
                    v-model="email"
                    type="text"
                    placeholder="Student's email"
                    class="form-control"
                  />
                </div>
              </div>
              <!-- /Student and Email -->

              <!-- Class -->
              <div class="form-row">
                <div class="form-group col-md-9">
                  <label>Class<span class="text-danger">*</span></label>
                  <div class="form-row">
                    <div class="col-md-4">
                      <select
                        v-model="subjectId"
                        class="form-control"
                        required
                        @change="onChangeSubject($event)"
                      >
                        <option value>-- Please Select Class Subject --</option>
                        <option
                          v-for="item in subjects"
                          :value="item.Id"
                          :key="item.Id"
                        >
                          {{ item.Name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mt-2 mt-md-0 mt-lg-0">
                      <select
                        v-model="subjectLevelId"
                        class="form-control"
                        required
                        @change="onChangeSubjectLevel($event)"
                      >
                        <option value>-- Please Select Subject Level --</option>
                        <option
                          v-for="item in subjectLevels"
                          :value="item.Id"
                          :key="item.Id"
                        >
                          {{ item.Name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 mt-2 mt-md-0 mt-lg-0">
                      <select
                        class="form-control"
                        v-model="duration"
                        required
                        @change="onChangeDuration($event)"
                      >
                        <option value>-- Please Select Duration --</option>
                        <option
                          v-for="item in durations"
                          :value="item.Duration"
                          :key="item.Duration"
                        >
                          {{ item.Duration }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Class -->

              <!-- Location -->
              <div class="form-row">
                <div
                  v-if="locations && locations.length"
                  :class="
                    showSchoolAddress
                      ? 'form-group col-md-9'
                      : 'form-group col-md-3'
                  "
                >
                  <label>Location</label>
                  <div class="form-row">
                    <div :class="showSchoolAddress ? 'col-md-4' : 'col-md-12'">
                      <select
                        class="form-control"
                        v-model="location"
                        @change="onChangeLocation($event)"
                      >
                        <option
                          v-for="(item, i) in locations"
                          :value="item.Name"
                          :key="i"
                        >
                          {{
                            item.Name
                              ? item.Name
                              : "-- Please Select Location --"
                          }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="col-md-8 mt-2 mt-md-0 mt-lg-0"
                      v-if="showSchoolAddress"
                    >
                      <select
                        class="form-control"
                        v-model="schoolAddressId"
                        @change="onChangeSchoolAddress($event)"
                        required
                      >
                        <option value>-- Please Select Address --</option>
                        <option
                          v-for="(item, i) in schoolAddresses"
                          :value="item.Id"
                          :key="i"
                        >
                          {{ item.Name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label>Make-up Class<span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="makeupClass"
                    required
                    @change="onChangeMakeup($event)"
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              <!-- /Location -->
            </div>
          </div>
        </div>
      </div>

      <!-- Date Time -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header text-center pb-0">
              <h3>Select a Date and Time</h3>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="thead-light">
                    <tr>
                      <th class="no-col">#</th>
                      <th class="date-col">Date/Time</th>
                      <th class="time-col"></th>
                      <th class="fee-col" v-if="makeupClass == 'No'">Fee</th>
                      <th class="instructor-col">Instructor</th>
                      <th class="action-col" v-if="!$route.params.id"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(rec, i) in bookingDateTimes" :key="i">
                      <td class="no-col">{{ i + 1 }}</td>
                      <td class="date-col">
                        <v-date-picker
                          v-model="rec.bookingDate"
                          :first-day-of-week="0"
                          :model-config="modelConfig"
                          :available-dates="rec.formattedAvailableDates"
                          v-if="makeupClass == 'No'"
                          :key="counter"
                          @dayclick="onDateClicked(i)"
                        />
                        <v-date-picker
                          v-model="rec.bookingDate"
                          :first-day-of-week="0"
                          :model-config="modelConfig"
                          v-if="makeupClass == 'Yes'"
                          :min-date="
                            tokenObj.UserType == userTypeStudent
                              ? new Date()
                              : ''
                          "
                          @dayclick="onDateClicked(i)"
                        />
                      </td>
                      <td class="time-col">
                        <div
                          :class="
                            rec.bookingDateDisplay ||
                            (rec.timezoneName && makeupClass == 'No')
                              ? 'mb-3'
                              : ''
                          "
                        >
                          <div>
                            <b>{{ rec.bookingDateDisplay }}</b>
                          </div>
                          <div v-if="rec.timezoneName && makeupClass == 'No'">
                            {{ rec.timezoneName }} time
                          </div>
                        </div>
                        <template v-if="makeupClass == 'Yes'">
                          <div style="display: flex">
                            <select
                              v-model="rec.makeupTimezoneId"
                              class="form-control form-control-sm fit-content mr-4"
                              required
                              @change="onChangeTimezone(i)"
                            >
                              <option value>
                                -- Please Select Time Zone --
                              </option>
                              <option
                                v-for="item in timezones"
                                :value="item.Id"
                                :key="item.Id"
                              >
                                {{ item.Name }}
                              </option>
                            </select>
                            <select
                              v-model="rec.makeupHour"
                              class="form-control form-control-sm fit-content"
                              required
                            >
                              <option value>0</option>
                              <option
                                v-for="item in timingHours"
                                :value="item"
                                :key="item"
                              >
                                {{ item }}
                              </option>
                            </select>
                            <span class="mx-2">:</span>
                            <select
                              v-model="rec.makeupMinute"
                              class="form-control form-control-sm fit-content"
                            >
                              <option
                                v-for="item in timingMinutes"
                                :value="item"
                                :key="item"
                              >
                                {{ item }}
                              </option>
                            </select>
                            <select
                              v-model="rec.makeupTimePart"
                              class="form-control form-control-sm ml-2 fit-content"
                              required
                            >
                              <option value="AM">AM</option>
                              <option value="PM">PM</option>
                            </select>
                          </div>
                        </template>
                        <template v-if="makeupClass == 'No'">
                          <div class="time-options">
                            <input
                              v-for="(item, j) in classes"
                              :key="j"
                              type="radio"
                              :id="'timing' + i + j"
                              name="timing"
                              :value="item.ClassId"
                              v-model="rec.classId"
                              @change="onChangeTime(i)"
                            />
                          </div>
                          <div class="timeoptions-div">
                            <template v-for="(item, j) in classes">
                              <label
                                :key="j"
                                :for="'timing' + i + j"
                                :class="
                                  rec.classId == item.ClassId ? 'bg-grey' : ''
                                "
                              >
                                <span class="timezone">
                                  {{ item.TimezoneName }}
                                </span>
                                <br />{{ item.Time }}
                              </label>
                              <br :key="'br' + j" v-if="(j + 1) % 2 == 0" />
                            </template>
                          </div>
                        </template>
                      </td>
                      <td
                        class="fee-col"
                        v-if="makeupClass == 'No'"
                        v-html="rec.feeAmountDisplay"
                      ></td>
                      <td class="instructor-col">
                        <select
                          class="form-control"
                          v-model="rec.instructorId"
                          required
                          @change="onChangeInstructor(i)"
                          :disabled="isInstructorPage"
                        >
                          <option value>-- Please Select Instructor --</option>
                          <template v-if="makeupClass == 'No'">
                            <option
                              v-for="item in rec.instructors"
                              :key="item.Id"
                              :value="item.Id"
                            >
                              {{ item.Name }}
                            </option>
                          </template>
                          <template v-if="makeupClass == 'Yes'">
                            <option
                              v-for="item in instructors"
                              :key="item.Id"
                              :value="item.Id"
                            >
                              {{ item.Name }}
                            </option>
                          </template>
                        </select>
                      </td>

                      <td class="action-col" v-if="!$route.params.id">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="addBookingDateTime"
                        >
                          <i class="fa fa-plus" title="Add Date and Time"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="removeBookingDateTime(i)"
                          v-if="bookingDateTimes.length > 1"
                        >
                          <i
                            class="fa fa-trash-o"
                            title="Remove Date and Time"
                          ></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Date Time -->

      <!-- Remarks -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header text-center pb-0">
              <h3>Remarks</h3>
            </div>
            <div class="card-body">
              <textarea
                v-model="remarks"
                placeholder="Input Remarks Here"
                class="form-control"
                maxlength="1000"
              >
              </textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- /Remarks -->

      <!-- Next Button -->
      <div class="text-center">
        <router-link
          v-if="!isStudent"
          class="btn btn-danger mr-4"
          :to="{ name: backToListingRouter }"
        >
          {{ $route.params.id ? "Cancel Update" : "Cancel" }}
        </router-link>
        <button class="btn btn-primary" type="submit">Next</button>
      </div>
      <!-- /Next Button -->
    </form>
    <!-- /Form -->

    <!-- Summary and Payment -->
    <form
      v-if="page == 2 && !isCapacityFull && !isError && !isSuccess"
      @submit.prevent="save"
    >
      <div class="row">
        <div :class="makeupClass == 'No' ? 'col-md-6' : 'col-md-12'">
          <div class="card">
            <div class="card-header text-center pb-2">
              <h3 class="card-title mb-0">Booking Summary</h3>
            </div>
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Name</b></label>
                  <div>{{ studentName }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Email</b></label>
                  <div>{{ email }}</div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Class Subject</b></label>
                  <div>{{ subjectName }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Subject Level</b></label>
                  <div>{{ subjectLevelName }}</div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Duration</b></label>
                  <div>{{ duration }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Make-up Class</b></label>
                  <div>{{ makeupClass }}</div>
                </div>
              </div>
              <div class="form-row" v-if="location">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Location</b></label>
                  <div>{{ location }}</div>
                </div>
                <div
                  class="form-group col-md-6"
                  v-if="location == 'School Address'"
                >
                  <label class="mb-0"><b>School Address</b></label>
                  <div>{{ schoolAddressName }}</div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead class="thead-light">
                        <tr>
                          <th class="no-col">#</th>
                          <th>Booking Date</th>
                          <th>Booking Time</th>
                          <th v-if="makeupClass == 'No'">
                            Fee ({{ bookingDateTimes[0].currency }})
                          </th>
                          <th>Instructor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, i) in bookingDateTimes" :key="i">
                          <td class="no-col">{{ i + 1 }}</td>
                          <td>{{ item.bookingDateDisplay }}</td>
                          <td>
                            {{
                              makeupClass == "No"
                                ? item.bookingTime
                                : `${item.makeupHour}:${item.makeupMinute} ${item.makeupTimePart}`
                            }}
                            ({{
                              makeupClass == "No"
                                ? item.timezoneName
                                : item.makeupTimezoneName
                            }})
                          </td>
                          <td v-if="makeupClass == 'No'" class="text-right">
                            {{ item.feeAmountPaid | formatFee }}
                          </td>
                          <td>{{ item.instructorName }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="form-row" v-if="remarks">
                <div class="form-group col-md-12">
                  <label class="mb-0"><b>Remarks</b></label>
                  <div>{{ remarks }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6" v-if="makeupClass == 'No'">
          <div class="card">
            <div class="card-header text-center pb-2">
              <h3 class="card-title mb-0">Payment</h3>
            </div>
            <div class="card-body">
              <div class="form-row">
                <div
                  class="form-group col-md-12 d-flex align-items-center justify-content-center"
                >
                  <label class="mr-3 total"><b>Total</b></label>
                  <label class="mr-1 currency">
                    <b>{{ bookingDateTimes[0].currency }}</b>
                  </label>
                  <label class="fee-amount">
                    <b>{{ totalFeeAmount | formatFee }}</b>
                  </label>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label>
                    <b>Select Payment Option</b>
                    <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    v-model="paymentOption"
                    required
                    @change="onChangePaymentOption($event)"
                  >
                    <option value>-- Please Select Payment Option --</option>
                    <option value="Prepaid">Prepaid</option>
                    <option value="Payment On-Site">Payment On-Site</option>
                    <option value="QR Payment">QR Payment</option>
                    <option value="Electronic Bank Transfer">
                      Electronic Bank Transfer
                    </option>
                    <option value="Cash">Cash</option>
                    <option value="Crossed Cheque">Crossed Cheque</option>
                  </select>
                </div>
              </div>
              <div
                class="form-row"
                v-if="
                  paymentOption == 'QR Payment' ||
                  paymentOption == 'Electronic Bank Transfer'
                "
              >
                <div
                  class="form-group col-md-12"
                  v-if="paymentOption == 'QR Payment'"
                >
                  <b>UEN:</b> {{ classes[0].Uen }}
                </div>
                <div
                  class="form-group col-md-12"
                  v-if="paymentOption == 'Electronic Bank Transfer'"
                >
                  <b>UEN:</b> {{ classes[0].Uen }}<br />
                  <b>SWIFT Code:</b> {{ classes[0].SwiftCode }}<br />
                  <b>Account Number:</b> {{ classes[0].AccountNumber }}<br />
                  <b>Account Name:</b> {{ classes[0].AccountName }}<br />
                  <b>Bank Name:</b> {{ classes[0].BankName }}<br />
                  <b>Bank Address:</b> {{ classes[0].BankAddress }}
                </div>
              </div>
              <div
                class="form-row"
                v-if="classes[0].Qr && paymentOption == 'QR Payment'"
              >
                <div class="form-group col-md-12 text-center">
                  <img :src="classes[0].Qr" style="width: 25%" />
                </div>
              </div>
              <div
                class="form-row"
                v-if="
                  paymentOption == 'QR Payment' ||
                  paymentOption == 'Electronic Bank Transfer' ||
                  paymentOption == 'Crossed Cheque'
                "
              >
                <div class="form-group col-md-12">
                  <label style="line-height: 17px">
                    <b>Upload Proof of Payment</b>
                    <span class="text-danger" v-if="!existingPaymentProof">
                      *
                    </span>
                    <br />
                    <span class="note">
                      (Maximum file size: 5 MB. Only zip, pdf, jpg, jpeg, png
                      are allowed)
                    </span>
                  </label>
                  <div v-if="$route.params.id && existingPaymentProof">
                    Existing file:
                    <button
                      type="button"
                      class="btn btn-link px-0"
                      @click="downloadExistingPaymentProof"
                    >
                      {{ existingFileNamePaymentProof }}
                    </button>
                  </div>
                  <div class="custom-file">
                    <input
                      type="file"
                      class="custom-file-input"
                      accept=".zip,.pdf,.jpg,.jpeg,.png"
                      id="proofUpload"
                      @change="onPaymentProofSelected($event)"
                      :required="!existingPaymentProof"
                    />
                    <label class="custom-file-label" for="proofUpload">
                      {{ fileNamePaymentProof }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Buttons -->
      <div class="text-center">
        <router-link
          v-if="!isStudent"
          class="btn btn-danger mr-4"
          :to="{ name: backToListingRouter }"
        >
          {{ $route.params.id ? "Cancel Update" : "Cancel" }}
        </router-link>
        <a class="btn btn-primary mr-4" @click="back">Back</a>
        <button class="btn btn-success" type="submit">
          {{ $route.params.id ? "Update" : "Submit" }}
        </button>
      </div>
      <!-- /Buttons -->
    </form>
    <!-- /Summary and Payment -->

    <!-- Error Page -->
    <div class="row" v-if="isCapacityFull || isError">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body" v-if="isCapacityFull">
            <template v-if="tokenObj.UserType == userTypeStudent">
              We're sorry, but due to real-time availability, the class you
              requested for is no longer available.
              <br />
              Please request for an alternative class or contact the School
              Admin for assistance.
              <br />
              Thank you.
            </template>
            <template v-else>
              We're sorry, but due to real-time availability, the class you
              requested for is no longer available.
              <br />
              Please request for an alternative class or increase the class
              capacity. <br />
              Thank you.
            </template>
          </div>
          <div class="card-body" v-else-if="isError">
            Sorry, there was an error while processing your request. Please
            <a href="javascript:void(0)" @click="$router.go()">
              reload the page
            </a>
            and try again.
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-if="isCapacityFull || isError">
      <router-link
        v-if="!isStudent"
        :class="
          isCapacityFull
            ? 'btn btn-primary mr-4 w-xs-40'
            : 'btn btn-primary mr-4'
        "
        :to="{ name: backToListingRouter }"
      >
        <i class="fa fa-reply mr-2"></i>Back to Class Bookings
      </router-link>
      <button v-if="isError" class="btn btn-secondary" @click="reportError">
        Report Error
      </button>
      <button
        v-if="isCapacityFull"
        class="btn btn-success w-xs-50"
        @click="submitAnotherClassBooking"
      >
        Submit Another Class Booking
      </button>
    </div>
    <!-- /Error Page -->

    <!-- Success Page -->
    <div class="row" v-if="isSuccess">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header text-center pb-2">
            <h3 class="card-title mb-0">Booking Summary</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6" v-if="$route.params.id">
                <label class="mb-0"><b>Modified by</b></label>
                <div>{{ modifiedBy }} at {{ modifiedDate }}</div>
              </div>
              <div class="form-group col-md-6" v-else>
                <label class="mb-0"><b>Submitted by</b></label>
                <div>{{ submittedBy }} at {{ submittedDate }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>School</b></label>
                <div>{{ schoolName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Name</b></label>
                <div>{{ studentName }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Email</b></label>
                <div>{{ email }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Class Subject</b></label>
                <div>{{ subjectName }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Subject Level</b></label>
                <div>{{ subjectLevelName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Duration</b></label>
                <div>{{ duration }}</div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Make-up Class</b></label>
                <div>{{ makeupClass }}</div>
              </div>
            </div>
            <div class="form-row" v-if="location">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Location</b></label>
                <div>{{ location }}</div>
              </div>
              <div
                class="form-group col-md-6"
                v-if="location == 'School Address'"
              >
                <label class="mb-0"><b>School Address</b></label>
                <div>{{ schoolAddressName }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th class="no-col">#</th>
                        <th>Booking Date</th>
                        <th>Booking Time</th>
                        <th v-if="makeupClass == 'No'">
                          Fee ({{ bookingDateTimes[0].currency }})
                        </th>
                        <th>Instructor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in bookingDateTimes" :key="i">
                        <td class="no-col">{{ i + 1 }}</td>
                        <td>{{ item.bookingDateDisplay }}</td>
                        <td>
                          {{
                            makeupClass == "No"
                              ? item.bookingTime
                              : `${item.makeupHour}:${item.makeupMinute} ${item.makeupTimePart}`
                          }}
                          ({{
                            makeupClass == "No"
                              ? item.timezoneName
                              : item.makeupTimezoneName
                          }})
                        </td>
                        <td v-if="makeupClass == 'No'" class="text-right">
                          {{ item.feeAmountPaid | formatFee }}
                        </td>
                        <td>{{ item.instructorName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="form-row" v-if="remarks">
              <div class="form-group col-md-12">
                <label class="mb-0"><b>Remarks</b></label>
                <div>{{ remarks }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card" v-if="makeupClass == 'No'">
          <div class="card-header text-center pb-2">
            <h3 class="card-title mb-0">Payment</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Total</b></label>
                <div>
                  {{ bookingDateTimes[0].currency }}
                  {{ totalFeeAmount | formatFee }}
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Payment Option</b></label>
                <div>{{ paymentOption }}</div>
              </div>
            </div>
            <template v-if="paymentOption == 'Electronic Bank Transfer'">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>UEN</b></label>
                  <div>{{ uen }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>SWIFT Code</b></label>
                  <div>{{ swiftCode }}</div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Account Number</b></label>
                  <div>{{ accountNumber }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Account Name</b></label>
                  <div>{{ accountName }}</div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Bank Name</b></label>
                  <div>{{ bankName }}</div>
                </div>
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Bank Address</b></label>
                  <div>{{ bankAddress }}</div>
                </div>
              </div>
              <div class="form-row" v-if="paymentProof || existingPaymentProof">
                <div class="form-group col-md-6">
                  <label class="mb-0"><b>Payment File</b></label>
                  <div>
                    <button
                      type="button"
                      class="btn btn-link p-0"
                      @click="
                        paymentProof
                          ? downloadPaymentProof()
                          : downloadExistingPaymentProof()
                      "
                    >
                      {{
                        paymentProof
                          ? fileNamePaymentProof
                          : existingFileNamePaymentProof
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <div
              class="form-row"
              v-if="
                paymentOption == 'QR Payment' ||
                paymentOption == 'Crossed Cheque'
              "
            >
              <div
                class="form-group col-md-6"
                v-if="paymentOption == 'QR Payment'"
              >
                <label class="mb-0"><b>UEN</b></label>
                <div>{{ uen }}</div>
              </div>
              <div
                class="form-group col-md-6"
                v-if="paymentProof || existingPaymentProof"
              >
                <label class="mb-0"><b>Payment File</b></label>
                <div>
                  <button
                    type="button"
                    class="btn btn-link p-0"
                    @click="
                      paymentProof
                        ? downloadPaymentProof()
                        : downloadExistingPaymentProof()
                    "
                  >
                    {{
                      paymentProof
                        ? fileNamePaymentProof
                        : existingFileNamePaymentProof
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header text-center pb-2">
            <h3 class="card-title mb-0">Status</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="mb-0"><b>Status</b></label>
                <div>
                  {{ status }}
                </div>
              </div>
              <div class="form-group col-md-6" v-if="confirmedDate">
                <label class="mb-0"><b>Confirmed by</b></label>
                <div>{{ confirmedBy }} at {{ confirmedDate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center desktop-show" v-if="isSuccess">
      <router-link
        v-if="!isStudent"
        class="btn btn-primary mr-4"
        :to="{ name: backToListingRouter }"
      >
        <i class="fa fa-reply mr-2"></i>Back to Class Bookings
      </router-link>
      <button class="btn btn-success mr-4" @click="submitAnotherClassBooking">
        Submit Another Class Booking
      </button>
      <button class="btn btn-secondary" @click="print">Print</button>
    </div>
    <div class="mobile-show" v-if="isSuccess">
      <div class="mb-3">
        <button
          class="btn btn-success w-100"
          @click="submitAnotherClassBooking"
        >
          Submit Another Class Booking
        </button>
      </div>
      <div class="mb-3">
        <button class="btn btn-secondary w-100" @click="print">Print</button>
      </div>
      <div>
        <router-link
          v-if="!isStudent"
          class="btn btn-primary w-100"
          :to="{ name: backToListingRouter }"
        >
          <i class="fa fa-reply mr-2"></i>Back to Class Bookings
        </router-link>
      </div>
    </div>
    <!-- /Success Page -->
  </div>
</template>

<script>
import axios from "axios";
import API from "../../../http-common.js";
import config from "../../../config.js";

export default {
  filters: {
    formatFee(val) {
      if (!val) return "";
      const options = { style: "decimal", minimumFractionDigits: 2 };
      return val.toLocaleString("en-US", options);
    },
  },
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      page: 1,
      instructorId: "", //for instructor page
      schoolId: "",
      schools: [],
      studentId: "",
      students: [],
      email: "",
      subjectId: "",
      subjects: [],
      subjectLevelId: "",
      subjectLevels: [],
      duration: "",
      durations: [],
      location: "",
      locations: [],
      schoolAddressId: "",
      schoolAddresses: [],
      makeupClass: "No",
      remarks: "",
      //date time, fee, and instructors
      classes: [],
      counter: 0,
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD",
      },
      bookingDateTimes: [
        {
          classId: "",
          formattedAvailableDates: [
            {
              start: new Date(1970, 1, 1),
              end: new Date(1970, 1, 1),
            },
          ],
          timezoneId: "",
          timezoneName: "",
          bookingDate: "",
          bookingTime: "",
          makeupHour: "",
          makeupMinute: "00",
          makeupTimePart: "AM",
          makeupTimezoneId: "",
          makeupTimezoneName: "",
          bookingDateDisplay: "",
          instructorId: "",
          instructorName: "",
          instructors: [],
          //related to fee
          currency: "",
          feeAmount: null,
          isInclusiveTax: false,
          isSalesTaxRegistered: false,
          salesTaxName: "",
          salesTaxPercentage: null,
          feeAmountPaid: null,
          feeAmountDisplay: "",
        },
      ],
      firstClassAvailableDates: [],
      timezones: [],
      defaultTimezoneId: "",
      //instructor
      instructors: [], //for make up = Yes
      //summary
      paymentOption: "",
      paymentProof: null,
      existingPaymentProof: null,
      fileNamePaymentProof: "Upload Proof of Payment",
      existingFileNamePaymentProof: "",
      //error panel
      isCapacityFull: false,
      isError: false,
      errorDate: null,
      errorMessage: "",
      //success panel
      isSuccess: false,
      submittedBy: "",
      submittedDate: "",
      modifiedBy: "",
      modifiedDate: "",
      confirmedBy: "",
      confirmedDate: "",
      uen: "",
      swiftCode: "",
      accountNumber: "",
      accountName: "",
      bankName: "",
      bankAddress: "",
      status: "",
      schoolName: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    isStudent() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data.UserType == this.userTypeStudent;
    },
    durationHour() {
      let output = "";
      if (this.duration) {
        let duration = this.durations.find((c) => c.Duration == this.duration);
        if (duration) output = duration.DurationHour;
      }
      return output;
    },
    durationMinute() {
      let output = "";
      if (this.duration) {
        let duration = this.durations.find((c) => c.Duration == this.duration);
        if (duration) output = duration.DurationMinute;
      }
      return output;
    },
    locationId() {
      let output = "";
      if (this.location) {
        let location = this.locations.find((c) => c.Name == this.location);
        if (location) output = location.Id;
      }
      return output;
    },
    locationOthers() {
      let output = "";
      if (this.location) {
        let location = this.locations.find((c) => c.Name == this.location);
        if (location) output = location.OthersName;
      }
      return output;
    },
    showSchoolAddress() {
      if (this.location) {
        let location = this.locations.find((c) => c.Name == this.location);
        if (location) {
          if (location.Name == "School Address") return true;
        }
      }
      return false;
    },
    timingHours() {
      let hours = [];
      for (let i = 1; i <= 12; i++) {
        hours.push(i);
      }
      return hours;
    },
    timingMinutes() {
      let minutes = [];
      for (let i = 0; i <= 59; i++) {
        minutes.push(i.toString().padStart(2, "0"));
      }
      return minutes;
    },
    studentName() {
      if (this.studentId) {
        var student = this.students.find((c) => c.Id == this.studentId);
        if (student) return student.Name;
      }
      return null;
    },
    subjectName() {
      if (this.subjectId) {
        var subject = this.subjects.find((c) => c.Id == this.subjectId);
        if (subject) return subject.Name;
      }
      return null;
    },
    subjectLevelName() {
      if (this.subjectLevelId) {
        var subjectLevel = this.subjectLevels.find(
          (c) => c.Id == this.subjectLevelId
        );
        if (subjectLevel) return subjectLevel.Name;
      }
      return null;
    },
    schoolAddressName() {
      if (this.location == "School Address" && this.schoolAddressId) {
        var schoolAddress = this.schoolAddresses.find(
          (c) => c.Id == this.schoolAddressId
        );
        if (schoolAddress) return schoolAddress.Name;
      }
      return null;
    },
    totalFeeAmount() {
      let totalFeeAmount = 0;
      for (let item of this.bookingDateTimes) {
        totalFeeAmount += item.feeAmountPaid;
      }
      return totalFeeAmount;
    },
    isInstructorPage() {
      return this.$route.path.includes("/instructor/");
    },
    backToListingRouter() {
      let routerName = "";
      if (this.tokenObj.UserType == this.userTypeStudent) {
        routerName = "studentMyClasses";
      } else if (this.tokenObj.UserType == this.userTypeInstructor) {
        routerName = "instructorMySchedule";
      } else if (this.tokenObj.UserType == this.userTypeMainAdmin) {
        routerName = "mainAdminClassBookingList";
      } else if (this.tokenObj.UserType == this.userTypeSchoolAdmin) {
        routerName = "schoolAdminClassBookingList";
      } else if (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin) {
        if (this.isInstructorPage) routerName = "instructorMySchedule";
        else routerName = "schoolAdminClassBookingList";
      }
      return routerName;
    },
    addClassBookingRouter() {
      let routerName = "";
      if (this.tokenObj.UserType == this.userTypeStudent) {
        routerName = "studentClassBookingForm";
      } else if (this.tokenObj.UserType == this.userTypeInstructor) {
        routerName = "instructorClassBookingAdd";
      } else if (this.tokenObj.UserType == this.userTypeMainAdmin) {
        routerName = "mainAdminClassBookingAdd";
      } else if (this.tokenObj.UserType == this.userTypeSchoolAdmin) {
        routerName = "schoolAdminClassBookingAdd";
      } else if (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin) {
        if (this.isInstructorPage) routerName = "instructorClassBookingAdd";
        else routerName = "schoolAdminClassBookingAdd";
      }
      return routerName;
    },
  },
  methods: {
    reset(type) {
      if (type == "student") {
        this.studentId = "";
        this.email = "";
        this.students = [];
      } else if (type == "subject") {
        this.subjectId = "";
        this.subjects = [];
      } else if (type == "subjectlevel") {
        this.subjectLevelId = "";
        this.subjectLevels = [];
        this.instructors = [];
      } else if (type == "duration") {
        this.duration = "";
        this.durations = [];
      } else if (type == "location") {
        this.location = "";
        this.locations = [];
        this.schoolAddressId = "";
        this.schoolAddresses = [];
      } else if (type == "datetime") {
        this.classes = [];
        this.firstClassAvailableDates = [];
        this.bookingDateTimes = [
          {
            classId: "",
            formattedAvailableDates: [
              {
                start: new Date(1970, 1, 1),
                end: new Date(1970, 1, 1),
              },
            ],
            timezoneId: "",
            timezoneName: "",
            bookingDate: "",
            bookingTime: "",
            makeupHour: "",
            makeupMinute: "00",
            makeupTimePart: "AM",
            makeupTimezoneId: this.defaultTimezoneId,
            makeupTimezoneName: this.defaultTimezoneId
              ? this.timezones.find((c) => c.Id == this.defaultTimezoneId) !=
                null
                ? this.timezones.find((c) => c.Id == this.defaultTimezoneId)
                    .Name
                : ""
              : "",
            bookingDateDisplay: "",
            instructorId: this.isInstructorPage ? this.instructorId : "",
            instructorName: this.isInstructorPage ? this.tokenObj.Name : "",
            instructors: [],
            currency: "",
            feeAmount: null,
            isInclusiveTax: false,
            isSalesTaxRegistered: false,
            salesTaxName: "",
            feeAmountPaid: null,
            feeAmountDisplay: "",
          },
        ];
      }
    },
    //school
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSchool(event) {
      this.reset("student");
      this.reset("subject");
      this.reset("subjectlevel");
      this.reset("duration");
      this.reset("location");
      this.reset("datetime");
      let schoolId = event.target.value;
      if (schoolId) {
        this.getSubjectsForClass(schoolId);
        this.getSchoolStudents(schoolId);
      }
    },
    //student
    getSchoolStudents(schoolId) {
      API.school
        .getSchoolStudents({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.students = response.data.data;
            if (this.tokenObj.UserType == this.userTypeStudent) {
              this.studentId = this.tokenObj.Id;
              let student = this.students.find((c) => c.Id == this.studentId);
              if (student) this.email = student.Email;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeStudent(event) {
      let studentId = event.target.value;
      if (studentId) {
        let student = this.students.find((c) => c.Id == studentId);
        if (student) this.email = student.Email;
      } else {
        this.email = "";
      }
    },
    //subject
    getSubjectsForClass(schoolId, instructorId) {
      API.subject
        .getSubjectsForClass({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
          InstructorId: instructorId,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjects = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSubject(event) {
      this.reset("subjectlevel");
      this.reset("duration");
      this.reset("location");
      this.reset("datetime");
      let subjectId = event.target.value;
      if (subjectId) {
        this.getSubjectLevelsForClassBooking(
          this.schoolId,
          subjectId,
          this.instructorId
        );
      }
    },
    //subject level
    getSubjectLevelsForClassBooking(schoolId, subjectId, instructorId) {
      API.classBooking
        .getSubjectLevelsForClassBooking({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
          SubjectId: subjectId,
          InstructorId: instructorId,
        })
        .then((response) => {
          if (response.data.success) {
            this.subjectLevels = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeSubjectLevel(event) {
      this.reset("duration");
      this.reset("location");
      this.reset("datetime");
      this.instructors = [];
      let subjectLevelId = event.target.value;
      if (subjectLevelId) {
        this.getDurationsForClassBooking(
          this.schoolId,
          this.subjectId,
          this.subjectLevelId,
          this.instructorId
        );
        this.getInstructorsForClassBooking(
          this.schoolId,
          this.subjectId,
          this.subjectLevelId
        );
      }
    },
    //duration
    getDurationsForClassBooking(
      schoolId,
      subjectId,
      subjectLevelId,
      instructorId
    ) {
      API.classBooking
        .getDurationsForClassBooking({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
          SubjectId: subjectId,
          SubjectLevelId: subjectLevelId,
          InstructorId: instructorId,
        })
        .then((response) => {
          if (response.data.success) {
            this.durations = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    onChangeDuration(event) {
      this.reset("location");
      this.reset("datetime");
      let duration = event.target.value;
      if (duration) {
        this.getLocationsForClassBooking(
          this.schoolId,
          this.subjectId,
          this.subjectLevelId,
          this.durationHour,
          this.durationMinute,
          this.instructorId
        );
      }
    },
    //location
    getLocationsForClassBooking(
      schoolId,
      subjectId,
      subjectLevelId,
      durationHour,
      durationMinute,
      instructorId
    ) {
      API.classBooking
        .getLocationsForClassBooking({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
          SubjectId: subjectId,
          SubjectLevelId: subjectLevelId,
          DurationHour: durationHour,
          DurationMinute: durationMinute,
          InstructorId: instructorId,
        })
        .then((response) => {
          if (response.data.success) {
            this.locations = response.data.data;
            if (!this.$route.params.id && !this.$store.state.class.classId)
              this.location = this.locations[0].Name;
            this.schoolAddresses = response.data.schoolAddresses;
            if (!this.showSchoolAddress) {
              this.getInfosForClassBooking(
                schoolId,
                subjectId,
                subjectLevelId,
                durationHour,
                durationMinute,
                this.locationId,
                this.locationOthers,
                "",
                this.instructorId
              );
            }
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onChangeLocation() {
      this.reset("datetime");
      if (!this.showSchoolAddress) {
        this.getInfosForClassBooking(
          this.schoolId,
          this.subjectId,
          this.subjectLevelId,
          this.durationHour,
          this.durationMinute,
          this.locationId,
          this.locationOthers,
          "",
          this.instructorId
        );
      } else {
        this.schoolAddressId = "";
      }
    },
    onChangeSchoolAddress(event) {
      // this.reset("datetime");
      let schoolAddressId = event.target.value;
      if (schoolAddressId) {
        this.getInfosForClassBooking(
          this.schoolId,
          this.subjectId,
          this.subjectLevelId,
          this.durationHour,
          this.durationMinute,
          this.locationId,
          this.locationOthers,
          schoolAddressId,
          this.instructorId
        );
      }
    },
    //date, time, fee, and instructors
    getInfosForClassBooking(
      schoolId,
      subjectId,
      subjectLevelId,
      durationHour,
      durationMinute,
      locationId,
      locationOthers,
      schoolAddressId,
      instructorId
    ) {
      this.$store.state.isLoading = true;
      API.classBooking
        .getInfosForClassBooking({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
          SubjectId: subjectId,
          SubjectLevelId: subjectLevelId,
          DurationHour: durationHour,
          DurationMinute: durationMinute,
          LocationId: locationId,
          LocationOthers: locationOthers,
          LocationSchoolAddressId: schoolAddressId,
          InstructorId: instructorId,
        })
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.classes = response.data.records;
            this.firstClassAvailableDates =
              response.data.records[0].AvailableDates;
            this.bookingDateTimes[0].formattedAvailableDates =
              this.formatAvailableDates(
                response.data.records[0].AvailableDates
              );
            if (this.$route.params.id || this.$store.state.class.classId) {
              let classId = this.bookingDateTimes[0].classId;
              let classRec = this.classes.find((c) => c.ClassId == classId);
              if (
                this.bookingDateTimes[0].bookingDate &&
                this.bookingDateTimes[0].bookingTime
              ) {
                this.getNonFullyBookedInstructors(
                  0,
                  classId,
                  classRec.Instructors,
                  this.schoolId,
                  this.subjectId,
                  this.subjectLevelId,
                  this.duration,
                  this.bookingDateTimes[0].timezoneName,
                  this.bookingDateTimes[0].bookingDate,
                  this.bookingDateTimes[0].bookingTime,
                  this.location,
                  this.locationId,
                  this.locationOthers,
                  this.schoolAddressId
                );
              } else {
                this.bookingDateTimes[0].instructors = classRec
                  ? classRec.Instructors
                  : [];
              }
            }
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    addBookingDateTime() {
      this.bookingDateTimes.push({
        classId: "",
        formattedAvailableDates: this.formatAvailableDates(
          this.firstClassAvailableDates
        ),
        timezoneId: "",
        timezoneName: "",
        bookingDate: "",
        bookingTime: "",
        makeupHour: "",
        makeupMinute: "00",
        makeupTimePart: "AM",
        makeupTimezoneId: this.defaultTimezoneId,
        makeupTimezoneName: this.defaultTimezoneId
          ? this.timezones.find((c) => c.Id == this.defaultTimezoneId) != null
            ? this.timezones.find((c) => c.Id == this.defaultTimezoneId).Name
            : ""
          : "",
        bookingDateDisplay: "",
        instructorId: this.isInstructorPage ? this.instructorId : "",
        instructorName: this.isInstructorPage ? this.tokenObj.Name : "",
        instructors: [],
        currency: "",
        feeAmount: null,
        isInclusiveTax: false,
        isSalesTaxRegistered: false,
        salesTaxName: "",
        feeAmountPaid: null,
        feeAmountDisplay: "",
      });
    },
    formatAvailableDates(payload) {
      let availableDates = [...payload];
      if (!availableDates.length) {
        availableDates = [
          {
            start: new Date(1970, 1, 1),
            end: new Date(1970, 1, 1),
          },
        ];
      }
      for (let date of availableDates) {
        date.start = new Date(date.start);
        date.end = new Date(date.end);
      }
      return availableDates;
    },
    removeBookingDateTime(index) {
      this.bookingDateTimes.splice(index, 1);
    },
    onDateClicked(index) {
      this.bookingDateTimes[index].bookingDateDisplay =
        this.getBookingDateDisplay(this.bookingDateTimes[index].bookingDate);
      //remove instructor if fully booked
      if (
        this.bookingDateTimes[index].bookingTime &&
        this.makeupClass == "No"
      ) {
        let classId = this.bookingDateTimes[index].classId;
        let classRec = this.classes.find((c) => c.ClassId == classId);
        this.getNonFullyBookedInstructors(
          index,
          classId,
          classRec.Instructors,
          this.schoolId,
          this.subjectId,
          this.subjectLevelId,
          this.duration,
          this.bookingDateTimes[index].timezoneName,
          this.bookingDateTimes[index].bookingDate,
          this.bookingDateTimes[index].bookingTime,
          this.location,
          this.locationId,
          this.locationOthers,
          this.schoolAddressId
        );
      }
    },
    getNonFullyBookedInstructors(
      index,
      classId,
      instructors,
      schoolId,
      subjectId,
      subjectLevelId,
      duration,
      timezoneName,
      bookingDate,
      bookingTime,
      location,
      locationId,
      locationOthers,
      locationSchoolAddressId
    ) {
      let param = {
        Token: this.tokenObj.Token,
        ClassId: classId,
        Instructors: instructors,
        SchoolId: schoolId,
        SubjectId: subjectId,
        SubjectLevelId: subjectLevelId,
        Duration: duration,
        TimezoneName: timezoneName,
        BookingDateForm: bookingDate,
        BookingTime: bookingTime,
        Location: location,
        LocationId: locationId,
        LocationOthers: locationOthers,
        LocationSchoolAddressId: locationSchoolAddressId,
      };
      API.classBooking
        .getNonFullyBookedInstructors(param)
        .then((response) => {
          if (response.data.success) {
            this.bookingDateTimes[index].instructors =
              response.data.instructors;

            if (this.bookingDateTimes[index].instructorId) {
              let instructorFound = response.data.instructors.find(
                (c) => c.Id == this.bookingDateTimes[index].instructorId
              );
              if (!instructorFound) {
                this.bookingDateTimes[index].instructorId = "";
                this.bookingDateTimes[index].instructorName = "";
              }
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getBookingDateDisplay(dateVal) {
      if (dateVal) {
        const bookingDate = new Date(dateVal);
        const daysOfWeek = [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
        let day = daysOfWeek[bookingDate.getDay()];
        let date = bookingDate.getDate();
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        let month = months[bookingDate.getMonth()];
        let year = bookingDate.getFullYear();
        return `${day}, ${date} ${month} ${year}`;
      }
      return "";
    },
    onChangeTime(index) {
      if (this.bookingDateTimes[index].classId) {
        let classId = this.bookingDateTimes[index].classId;
        let classRec = this.classes.find((c) => c.ClassId == classId);
        this.bookingDateTimes[index].formattedAvailableDates =
          this.formatAvailableDates(classRec.AvailableDates);
        this.bookingDateTimes[index].timezoneName = classRec.TimezoneName;
        this.bookingDateTimes[index].bookingTime = classRec.Time;
        //remove instructor if fully booked
        if (
          this.bookingDateTimes[index].bookingDate &&
          this.makeupClass == "No"
        ) {
          this.getNonFullyBookedInstructors(
            index,
            classId,
            classRec.Instructors,
            this.schoolId,
            this.subjectId,
            this.subjectLevelId,
            this.duration,
            this.bookingDateTimes[index].timezoneName,
            this.bookingDateTimes[index].bookingDate,
            this.bookingDateTimes[index].bookingTime,
            this.location,
            this.locationId,
            this.locationOthers,
            this.schoolAddressId
          );
        }

        this.bookingDateTimes[index].instructorId = this.isInstructorPage
          ? this.instructorId
          : "";
        this.bookingDateTimes[index].instructorName = this.isInstructorPage
          ? this.tokenObj.Name
          : "";
        //populate fee related
        this.bookingDateTimes[index].currency = classRec.Currency;
        this.bookingDateTimes[index].feeAmount = classRec.FeeAmount;
        this.bookingDateTimes[index].isInclusiveTax = classRec.IsInclusiveTax;
        this.bookingDateTimes[index].isSalesTaxRegistered =
          classRec.IsSalesTaxRegistered;
        this.bookingDateTimes[index].salesTaxName = classRec.SalesTaxName;
        this.bookingDateTimes[index].salesTaxPercentage =
          classRec.SalesTaxPercentage;
        //populate fee-amount-paid and fee-displayed
        const options = { style: "decimal", minimumFractionDigits: 2 };
        let feeAmount = parseFloat(classRec.FeeAmount ? classRec.FeeAmount : 0);
        if (classRec.IsSalesTaxRegistered) {
          if (classRec.IsInclusiveTax) {
            this.bookingDateTimes[index].feeAmountPaid = feeAmount;
            this.bookingDateTimes[
              index
            ].feeAmountDisplay = `<b>Amount Due (inclusive of ${
              classRec.SalesTaxName
            } at ${classRec.SalesTaxPercentage}%) = ${
              classRec.Currency
            } ${feeAmount.toLocaleString("en-US", options)}</b>`;
          } else {
            let taxAmount = (classRec.SalesTaxPercentage * feeAmount) / 100;
            let feeAmountAfterTax = feeAmount + taxAmount;
            this.bookingDateTimes[index].feeAmountPaid = feeAmountAfterTax;
            this.bookingDateTimes[index].feeAmountDisplay = `${
              classRec.Currency
            } ${feeAmount.toLocaleString("en-US", options)} <br/> Add ${
              classRec.SalesTaxName
            } at ${classRec.SalesTaxPercentage}% = ${
              classRec.Currency
            } ${taxAmount.toLocaleString(
              "en-US",
              options
            )} <br/> <b>Amount Due = ${
              classRec.Currency
            } ${feeAmountAfterTax.toLocaleString("en-US", options)}</b>`;
          }
        } else {
          this.bookingDateTimes[index].feeAmountPaid = feeAmount;
          this.bookingDateTimes[index].feeAmountDisplay = `<b>Amount Due = ${
            classRec.Currency
          } ${feeAmount.toLocaleString("en-US", options)}</b>`;
        }
      }
    },
    onChangeTimezone(index) {
      let timezoneId = this.bookingDateTimes[index].makeupTimezoneId;
      this.bookingDateTimes[index].makeupTimezoneName = this.timezones.find(
        (c) => c.Id == timezoneId
      ).Name;
    },
    onChangeInstructor(index) {
      let instructorId = this.bookingDateTimes[index].instructorId;
      let instructors =
        this.makeupClass == "No"
          ? this.bookingDateTimes[index].instructors
          : this.instructors;
      this.bookingDateTimes[index].instructorName = instructors.find(
        (c) => c.Id == instructorId
      ).Name;
    },
    getTimezones() {
      API.common
        .getTimezones({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.timezones = response.data.data;
            this.getGeolocation();
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getGeolocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError,
          { timeout: 300000, maximumAge: 1800000 }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    showPosition(position) {
      const { latitude, longitude } = position.coords;
      this.$store.state.isLoading = true;
      axios
        .get(
          `https://api.timezonedb.com/v2.1/get-time-zone?key=GS66VJW5BPIQ&format=json&by=position&lat=${latitude}&lng=${longitude}`
        )
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.status == 200) {
            let timezone = this.timezones.find(
              (c) => c.Name == response.data.zoneName
            );
            if (timezone) {
              this.bookingDateTimes[0].makeupTimezoneId = timezone.Id;
              this.bookingDateTimes[0].makeupTimezoneName = this.timezones.find(
                (c) => c.Id == timezone.Id
              ).Name;
              this.defaultTimezoneId = timezone.Id;
            }
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.error("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          console.error("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          console.error("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          console.error("An unknown error occurred.");
          break;
        default:
          console.error("An unknown error occurred.");
      }
    },
    // make up
    onChangeMakeup(event) {
      let val = event.target.value;
      if (val == "Yes") {
        if (this.bookingDateTimes.length >= 2) this.bookingDateTimes.splice(1);
      }
      this.bookingDateTimes[0].bookingDate = "";
      this.bookingDateTimes[0].bookingDateDisplay = "";
      this.bookingDateTimes[0].instructorId = this.isInstructorPage
        ? this.instructorId
        : "";
      this.bookingDateTimes[0].instructorName = this.isInstructorPage
        ? this.tokenObj.Name
        : "";
    },
    getInstructorsForClassBooking(schoolId, subjectId, subjectLevelId) {
      API.classBooking
        .getInstructorsForClassBooking({
          Token: this.tokenObj.Token,
          SchoolId: schoolId,
          SubjectId: subjectId,
          SubjectLevelId: subjectLevelId,
        })
        .then((response) => {
          if (response.data.success) {
            this.instructors = response.data.data;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //back and next
    back() {
      this.page = 1;
      this.paymentProof = null;
      this.fileNamePaymentProof = "Upload Proof of Payment";
    },
    next() {
      //check for empty date
      for (let item of this.bookingDateTimes) {
        if (!item.bookingDate) {
          this.$swal("Please select a date", { icon: "error" });
          return;
        }
      }
      //check for duplicate date time
      for (let i = 0; i < this.bookingDateTimes.length; i++) {
        for (let j = 0; j < this.bookingDateTimes.length; j++) {
          if (i == j) continue;
          let bookingDate1 = this.bookingDateTimes[i].bookingDate;
          let bookingDate2 = this.bookingDateTimes[j].bookingDate;
          if (this.makeupClass == "No") {
            let bookingTime1 = this.bookingDateTimes[i].bookingTime;
            let bookingTime2 = this.bookingDateTimes[j].bookingTime;
            let timezone1 = this.bookingDateTimes[i].timezoneName;
            let timezone2 = this.bookingDateTimes[j].timezoneName;
            if (
              bookingDate1 == bookingDate2 &&
              bookingTime1 == bookingTime2 &&
              timezone1 == timezone2
            ) {
              this.$swal("Duplicate booking date and time detected", {
                icon: "error",
              });
              return;
            }
          } else {
            let makeupHour1 = this.bookingDateTimes[i].makeupHour;
            let makeupHour2 = this.bookingDateTimes[j].makeupHour;
            let makeupMinute1 = this.bookingDateTimes[i].makeupMinute;
            let makeupMinute2 = this.bookingDateTimes[j].makeupMinute;
            let makeupTimePart1 = this.bookingDateTimes[i].makeupTimePart;
            let makeupTimePart2 = this.bookingDateTimes[j].makeupTimePart;
            let makeupTimezoneId1 = this.bookingDateTimes[i].makeupTimezoneId;
            let makeupTimezoneId2 = this.bookingDateTimes[j].makeupTimezoneId;
            if (
              bookingDate1 == bookingDate2 &&
              makeupHour1 == makeupHour2 &&
              makeupMinute1 == makeupMinute2 &&
              makeupTimePart1 == makeupTimePart2 &&
              makeupTimezoneId1 == makeupTimezoneId2
            ) {
              this.$swal("Duplicate booking date and time detected", {
                icon: "error",
              });
              return;
            }
          }
        }
      }
      //check overlap when makeupClass = Yes
      if (this.makeupClass == "Yes") {
        let param = {
          Token: this.tokenObj.Token,
          Id: this.$route.params.id,
          DurationHour: this.durationHour,
          DurationMinute: this.durationMinute,
          BookingDateTimes: this.bookingDateTimes,
        };
        this.$store.state.isLoading = true;
        API.classBooking
          .checkOverlapMakeupClass(param)
          .then((response) => {
            this.$store.state.isLoading = false;
            if (response.data.success) {
              if (response.data.hasOverlap) {
                this.$swal("The selected date and time is not available", {
                  icon: "error",
                });
                return;
              } else this.page = 2;
            }
          })
          .catch((error) => {
            console.log(error);
            this.$store.state.isLoading = false;
            this.$swal(error.response.data.Message, { icon: "error" });
          });
      } else {
        this.page = 2;
      }
    },
    //payment
    onChangePaymentOption() {
      this.paymentProof = null;
      this.fileNamePaymentProof = "Upload Proof of Payment";
    },
    //proof upload
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    onPaymentProofSelected(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        this.$swal("File size exceeds 5 MB", { icon: "error" });
        return;
      }
      this.fileNamePaymentProof = file.name;
      let self = this;
      let promise = self.getBase64(file);
      promise.then(function (result) {
        self.paymentProof = result;
      });
    },
    downloadExistingPaymentProof() {
      const base64String = this.existingPaymentProof.split(",")[1];
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = this.existingFileNamePaymentProof;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    downloadPaymentProof() {
      const base64String = this.paymentProof.split(",")[1];
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = this.fileNamePaymentProof;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //main functions
    save() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
        StudentId: this.studentId,
        SubjectId: this.subjectId,
        SubjectLevelId: this.subjectLevelId,
        MakeupClass: this.makeupClass,
        BookingDateTimes: this.bookingDateTimes,
      };
      API.classBooking
        .checkDuplicateClassBooking(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success)
            if (response.data.hasClassForStudent) {
              let msg =
                this.tokenObj.UserType == this.userTypeStudent
                  ? "You already have a class booking on the selected date and time. Please select another date or time."
                  : "The selected student already has a class booking on the selected date and time. Please select another date or time.";
              this.$swal(msg, { icon: "error" });
              return;
            } else {
              this.saveClassBooking(response.data.hasDuplicate);
            }
        })
        .catch((error) => {
          console.log(error);
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    saveClassBooking(hasDuplicate) {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
        SchoolId: this.schoolId,
        StudentId: this.studentId,
        SubjectId: this.subjectId,
        SubjectLevelId: this.subjectLevelId,
        Duration: this.duration,
        DurationHour: this.durationHour,
        DurationMinute: this.durationMinute,
        Location: this.location,
        LocationId: this.locationId,
        LocationOthers: this.locationOthers,
        LocationSchoolAddressId: this.schoolAddressId,
        MakeupClass: this.makeupClass,
        Remarks: this.remarks,
        BookingDateTimes: this.bookingDateTimes,
        UEN: this.classes[0].Uen,
        PaymentOption: this.paymentOption,
        PaymentProof: this.paymentProof,
        PaymentProofFileName:
          this.fileNamePaymentProof == "Upload Proof of Payment"
            ? null
            : this.fileNamePaymentProof,
      };
      let duplicateMsg = hasDuplicate ? "This class already exists. " : "";
      let action = this.$route.params.id ? "update" : "submit";
      let text = `${duplicateMsg}Are you sure you want to ${action} the class booking?`;
      this.$swal({
        title: "Are you sure?",
        text: text,
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .saveClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              if (!response.data.success) {
                if (response.data.hasExistingClassBooking) {
                  this.$swal(response.data.message, { icon: "error" });
                } else if (response.data.isCapacityFull) {
                  this.isCapacityFull = true;
                } else if (response.data.isError) {
                  this.isError = true;
                  this.errorDate = response.data.errorDate;
                  this.errorMessage = response.data.message;
                }
                return;
              } else {
                this.isSuccess = true;
                let classBooking = response.data.classBooking;
                this.submittedBy = classBooking.SubmittedBy;
                this.submittedDate = classBooking.SubmittedDateDisplay;
                this.modifiedBy = classBooking.ModifiedBy;
                this.modifiedDate = classBooking.ModifiedDateDisplay;
                this.uen = classBooking.UEN;
                this.swiftCode = classBooking.SwiftCode;
                this.accountNumber = classBooking.AccountNumber;
                this.accountName = classBooking.AccountName;
                this.bankName = classBooking.BankName;
                this.bankAddress = classBooking.BankAddress;
                this.confirmedBy = classBooking.ConfirmedBy;
                this.confirmedDate = classBooking.ConfirmedDateDisplay;
                this.status = classBooking.Status;
                this.schoolName = classBooking.SchoolName;
              }
            })
            .catch((error) => {
              console.log(error);
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    submitAnotherClassBooking() {
      if (this.$route.params.id) {
        this.$router.replace({ name: this.addClassBookingRouter });
      }
      this.$router.go();
    },
    reportError() {
      let param = {
        Token: this.tokenObj.Token,
        ErrorDate: this.errorDate,
        ErrorMessage: this.errorMessage,
        SchoolId: this.schoolId,
        StudentName: this.studentName,
        StudentEmail: this.email,
        SubjectName: this.subjectName,
        SubjectLevelName: this.subjectLevelName,
        Duration: this.duration,
        Location: this.location,
        LocationId: this.locationId,
        LocationOthers: this.locationOthers,
        LocationSchoolAddressName: this.schoolAddressName,
        MakeupClass: this.makeupClass,
        BookingDateTimes: this.bookingDateTimes,
        UEN: this.classes[0].Uen,
        Currency: this.bookingDateTimes[0].currency,
        TotalPayment: this.totalFeeAmount,
        PaymentOption: this.paymentOption,
        PaymentProof: this.paymentProof,
        PaymentProofFileName:
          this.fileNamePaymentProof == "Upload Proof of Payment"
            ? null
            : this.fileNamePaymentProof,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are your sure you want to submit the error report?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .reportError(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.$router.replace({ name: this.backToListingRouter });
              }
            })
            .catch((error) => {
              console.log(error);
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    print() {
      let locationHtml = `${
        this.location
          ? `<div class="form-row">
          <div class="form-group col-md-5">
            <label><b>Location</b></label>
            <div>${this.location}</div>
          </div>
          ${
            this.location == "School Address"
              ? `<div class="form-group col-md-5">
            <label><b>School Address</b></label>
            <div>${this.schoolAddressName}</div>
          </div>`
              : ""
          }
        </div>`
          : ""
      }`;

      let bookingDateTimesHtml = "";
      for (let i = 0; i < this.bookingDateTimes.length; i++) {
        let item = this.bookingDateTimes[i];
        bookingDateTimesHtml += `<tr>
          <td>${i + 1}</td>
          <td>${item.bookingDateDisplay}</td>
          <td>
            ${
              this.makeupClass == "No"
                ? item.bookingTime
                : `${item.makeupHour}:${item.makeupMinute} ${item.makeupTimePart}`
            } 
            (${
              this.makeupClass == "No"
                ? item.timezoneName
                : item.makeupTimezoneName
            })
          </td>
          ${this.makeupClass == "No" ? `<td>${item.feeAmountPaid}</td>` : ""}
          <td>${item.instructorName}</td>
        </tr>`;
      }

      let remarksHtml = this.remarks
        ? `<div class="form-row">
            <div class="form-group col-md-12">
              <label><b>Remarks</b></label>
              <div>${this.remarks}</div>
            </div>
          </div>`
        : "";

      let paymentHtml = "";
      if (this.makeupClass == "No") {
        let paymentDetailHtml = "";
        if (this.paymentOption == "Electronic Bank Transfer") {
          paymentDetailHtml = `<div class="form-row">
              <div class="form-group col-md-5">
                <label><b>UEN</b></label>
                <div>${this.uen}</div>
              </div>
              <div class="form-group col-md-5">
                <label><b>SWIFT Code</b></label>
                <div>${this.swiftCode}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-5">
                <label><b>Account Number</b></label>
                <div>${this.accountNumber}</div>
              </div>
              <div class="form-group col-md-5">
                <label><b>Account Name</b></label>
                <div>${this.accountName}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-5">
                <label><b>Bank Name</b></label>
                <div>${this.bankName}</div>
              </div>
              <div class="form-group col-md-5">
                <label><b>Bank Address</b></label>
                <div>${this.bankAddress}</div>
              </div>
            </div>
            ${
              this.paymentProof || this.existingPaymentProof
                ? `<div class="form-row">
              <div class="form-group col-md-5">
                <label><b>Payment File</b></label>
                <div>${
                  this.paymentProof
                    ? this.fileNamePaymentProof
                    : this.existingFileNamePaymentProof
                }</div>
              </div>
            </div>`
                : ""
            }`;
        } else if (
          this.paymentOption == "QR Payment" ||
          this.paymentOption == "Crossed Cheque"
        ) {
          paymentDetailHtml = `<div class="form-row">
              ${
                this.paymentOption == "QR Payment"
                  ? `<div class="form-group col-md-5">
                    <label><b>UEN</b></label>
                    <div>${this.uen}</div>
                  </div>`
                  : ""
              }
              ${
                this.paymentProof || this.existingPaymentProof
                  ? `<div class="form-group col-md-5">
                    <label><b>Payment File</b></label>
                    <div>${
                      this.paymentProof
                        ? this.fileNamePaymentProof
                        : this.existingFileNamePaymentProof
                    }</div>
                  </div>`
                  : ""
              }
            </div>`;
        }

        paymentHtml = `<div class="card">
          <div class="card-header text-center">
            <h3>Payment</h3>
          </div>
          <div class="card-body">
            <div class="form-row">
              <div class="form-group col-md-5">
                <label><b>Total</b></label>
                <div>
                  ${this.bookingDateTimes[0].currency} ${this.totalFeeAmount}
                </div>
              </div>
              <div class="form-group col-md-5">
                <label><b>Payment Option</b></label>
                <div>${this.paymentOption}</div>
              </div>
            </div>
            ${paymentDetailHtml}
          </div>
        </div>`;
      }

      let confirmedByHtml = `${
        this.confirmedDate
          ? `<div class="form-group col-md-5">
          <label><b>Confirmed by</b></label>
          <div>${this.confirmedBy} at ${this.confirmedDate}</div>
        </div>`
          : ""
      }`;

      let html = `<html>
      <head>
        <style>
          @media print {
            body {
              -webkit-print-color-adjust: exact;
              font-family: Arial, Helvetica, sans-serif;
            }
          }
          body{
            font-family: Arial, Helvetica, sans-serif;
          }
          @page{size:auto; margin:5mm;}
          h3{margin: 10px;}
          .text-center{text-align: center !important;}
          .row{
            display: -ms-flexbox;
            display: -webkit-box;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            margin-right: -15px;
            margin-left: -15px;
          }
          .form-row{
            display: -ms-flexbox;
            display: -webkit-box;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            margin-right: -5px;
            margin-left: -5px;
          }
          .form-group{
            margin-bottom: 1rem;
          }
          .form-group label{
            margin-bottom: 0.25rem;
          }
          .col-md-12{
            -ms-flex: 0 0 92%;
            -webkit-box-flex: 0;
            flex: 0 0 92%;
            max-width: 92%;
            position: relative;
            width: 100%;
            padding-right: 15px;
            padding-left: 15px;
          }
          .col-md-6{
            -ms-flex: 0 0 46%;
            -webkit-box-flex: 0;
            flex: 0 0 46%;
            max-width: 46%;
            position: relative;
            width: 100%;
            padding-right: 15px;
            padding-left: 15px;
          }
          .col-md-5{
            -ms-flex: 0 0 41%;
            -webkit-box-flex: 0;
            flex: 0 0 41%;
            max-width: 41%;
            position: relative;
            width: 100%;
            padding-right: 15px;
            padding-left: 15px;
          }
          .card{
            border: 1px solid #a7a7a7;
            -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
            box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
            margin-bottom: 30px;
            position: relative;
            display: -ms-flexbox;
            display: -webkit-box;
            display: flex;
            -ms-flex-direction: column;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            flex-direction: column;
            min-width: 0;
            word-wrap: break-word;
            background-color: #fff;
            background-clip: border-box;
            border-radius: 0.25rem;
          }
          .card-header:first-child{
            border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
          }
          .card-header{
            background-color: #fff;
            padding: 0rem 1.25rem;
            margin-bottom: 0;
            border-bottom: 1px solid #a7a7a7;
          }
          .card-body{
            font-size: 14px;
            -ms-flex: 1 1 auto;
            -webkit-box-flex: 1;
            flex: 1 1 auto;
            min-height: 1px;
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
          }
          .table{
            width: 340px;
            margin-left: 0.5rem;
            margin-right: 0.5rem;
            margin-bottom: 1rem;
            color: #212529;
            border-collapse: collapse;
          }
          .table-bordered{
            border: 1px solid #dee2e6;
          }
          .table-bordered td{
            font-size: 12px;
            border: 1px solid #dee2e6;
            padding: .20rem;
            vertical-align: middle;
          }
        </style>
      </head>
      <body>
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header text-center">
                <h3>Booking Summary</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label><b>${
                      this.$route.params.id ? "Modified by" : "Submitted by"
                    }</b></label>
                    <div>
                      ${
                        this.$route.params.id
                          ? this.modifiedBy
                          : this.submittedBy
                      } at 
                      ${
                        this.$route.params.id
                          ? this.modifiedDate
                          : this.submittedDate
                      }
                    </div>
                  </div>
                  <div class="form-group col-md-5">
                    <label><b>School</b></label>
                    <div>${this.schoolName}</div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label><b>Name</b></label>
                    <div>${this.studentName}</div>
                  </div>
                  <div class="form-group col-md-5">
                    <label><b>Email</b></label>
                    <div>${this.email}</div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label><b>Class Subject</b></label>
                    <div>${this.subjectName}</div>
                  </div>
                  <div class="form-group col-md-5">
                    <label><b>Subject Level</b></label>
                    <div>${this.subjectLevelName}</div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label><b>Duration</b></label>
                    <div>${this.duration}</div>
                  </div>
                  <div class="form-group col-md-5">
                    <label><b>Make-up Class</b></label>
                    <div>${this.makeupClass}</div>
                  </div>
                </div>
                ${locationHtml}
                <table class="table table-bordered">
                  <tr style="background-color: #f8f4f4">
                    <td><b>#</b></td>
                    <td><b>Booking Date</b></td>
                    <td><b>Booking Time</b></td>
                    ${
                      this.makeupClass == "No"
                        ? `<td><b>Fee (${this.bookingDateTimes[0].currency})</b></td>`
                        : ""
                    }
                    <td><b>Instructor</b></td>
                  </tr>
                  ${bookingDateTimesHtml}
                </table>
                ${remarksHtml}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            ${paymentHtml}
            <div class="card">
              <div class="card-header text-center">
                <h3>Status</h3>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label><b>Status</b></label>
                    <div>${this.status}</div>
                  </div>
                  ${confirmedByHtml}
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
      </html>`;
      // let w = window.open("", "PRINT", "height=700,width=1300");
      // w.document.write(html);
      // // for i.e
      // w.document.close();
      // w.focus();
      // //for the rest
      // window.setTimeout(() => {
      //   w.print();
      //   w.close();
      // }, 500);
      const printFrame = document.createElement("iframe");
      printFrame.style.position = "absolute";
      printFrame.style.width = "0";
      printFrame.style.height = "0";
      printFrame.style.border = "none";
      document.body.appendChild(printFrame);
      const printDocument =
        printFrame.contentWindow || printFrame.contentDocument;
      printDocument.document.open();
      printDocument.document.write(html);
      printDocument.document.close();
      printFrame.contentWindow.focus();
      try {
        printFrame.contentWindow.print();
      } catch (e) {
        console.log(e.message);
      }
      printFrame.contentWindow.onafterprint = () => {
        document.body.removeChild(printFrame);
      };
    },
    getClassBookingDetail() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.classBooking
        .getClassBookingDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let data = response.data.data;
            this.remarks = data.Remarks;
            this.schoolId = data.SchoolId;
            this.getSchoolStudents(data.SchoolId);
            this.studentId = data.StudentId;
            this.email = data.StudentEmail;
            this.subjectId = data.SubjectId;
            this.getSubjectsForClass(data.SchoolId);
            this.subjectLevelId = data.SubjectLevelId;
            this.getSubjectLevelsForClassBooking(data.SchoolId, data.SubjectId);
            this.duration = data.Duration;
            this.getDurationsForClassBooking(
              data.SchoolId,
              data.SubjectId,
              data.SubjectLevelId
            );
            this.getInstructorsForClassBooking(
              data.SchoolId,
              data.SubjectId,
              data.SubjectLevelId
            );
            this.location = data.Location;
            this.schoolAddressId = data.LocationSchoolAddressId;
            //populate locations
            let durationHour = null;
            let durationMinute = null;
            if (data.Duration.includes("h")) {
              let durationArr = data.Duration.split("-");
              durationHour = parseInt(
                durationArr[0].replace("h", "").replace(" ", "")
              );
              durationMinute = durationArr[1]
                ? parseInt(durationArr[1].replace("m", "").replace(" ", ""))
                : null;
            } else {
              durationMinute = parseInt(data.Duration.replace("m", ""));
            }
            this.getLocationsForClassBooking(
              data.SchoolId,
              data.SubjectId,
              data.SubjectLevelId,
              durationHour,
              durationMinute
            );
            //populate booking datetimes
            this.bookingDateTimes[0].bookingDate = data.BookingDateCal;
            this.bookingDateTimes[0].bookingDateDisplay =
              data.BookingDateDisplay;
            if (data.MakeupClass == "No") {
              this.bookingDateTimes[0].classId = data.ClassId;
              this.bookingDateTimes[0].bookingTime = data.BookingTime;
              this.bookingDateTimes[0].timezoneId = data.TimezoneId;
              this.bookingDateTimes[0].timezoneName = data.TimezoneName;
              this.counter++;
            } else {
              let timingArr = data.BookingTime.split(" ");
              let hourMinutePart = timingArr[0];
              let hourMinuteArr = hourMinutePart.split(":");
              this.bookingDateTimes[0].makeupHour = hourMinuteArr[0];
              this.bookingDateTimes[0].makeupMinute = hourMinuteArr[1];
              this.bookingDateTimes[0].makeupTimePart = timingArr[1];
              this.bookingDateTimes[0].makeupTimezoneId = data.TimezoneId;
              this.bookingDateTimes[0].makeupTimezoneName = data.TimezoneName;
            }
            this.bookingDateTimes[0].instructorId = data.InstructorId;
            this.bookingDateTimes[0].instructorName = data.InstructorName;
            this.bookingDateTimes[0].currency = data.Currency;
            this.bookingDateTimes[0].feeAmount = data.FeeAmount;
            this.bookingDateTimes[0].isInclusiveTax =
              data.IsInclusiveOfSalesTax;
            this.bookingDateTimes[0].isSalesTaxRegistered =
              data.IsSalesTaxRegistered;
            this.bookingDateTimes[0].salesTaxName = data.SalesTaxName;
            this.bookingDateTimes[0].salesTaxPercentage =
              data.SalesTaxPercentage;
            this.bookingDateTimes[0].feeAmountPaid = data.FeeAmountPaid;
            //populate feeAmountDisplay
            const options = { style: "decimal", minimumFractionDigits: 2 };
            let feeAmount = parseFloat(data.FeeAmount ? data.FeeAmount : 0);
            if (data.IsSalesTaxRegistered) {
              if (data.IsInclusiveOfSalesTax) {
                this.bookingDateTimes[0].feeAmountDisplay = `<b>Amount Due (inclusive of ${
                  data.SalesTaxName
                } at ${data.SalesTaxPercentage}%) = ${
                  data.Currency
                } ${feeAmount.toLocaleString("en-US", options)}</b>`;
              } else {
                let salesTaxPercentage = parseFloat(
                  data.SalesTaxPercentage ? data.SalesTaxPercentage : 0
                );
                let taxAmount = (salesTaxPercentage * feeAmount) / 100;
                let feeAmountAfterTax = feeAmount + taxAmount;
                this.bookingDateTimes[0].feeAmountDisplay = `${
                  data.Currency
                } ${feeAmount.toLocaleString("en-US", options)} <br/> Add ${
                  data.SalesTaxName
                } at ${salesTaxPercentage}% = ${
                  data.Currency
                } ${taxAmount.toLocaleString(
                  "en-US",
                  options
                )} <br/> <b>Amount Due = ${
                  data.Currency
                } ${feeAmountAfterTax.toLocaleString("en-US", options)}</b>`;
              }
            } else {
              this.bookingDateTimes[0].feeAmountDisplay = `<b>Amount Due = ${
                data.Currency
              } ${feeAmount.toLocaleString("en-US", options)}</b>`;
            }
            this.getInfosForClassBooking(
              data.SchoolId,
              data.SubjectId,
              data.SubjectLevelId,
              durationHour,
              durationMinute,
              data.LocationId,
              data.LocationOthers,
              data.LocationSchoolAddressId
            );
            this.makeupClass = data.MakeupClass;
            this.paymentOption = data.PaymentOption;
            this.existingPaymentProof = data.PaymentProof;
            this.existingFileNamePaymentProof = data.PaymentProofFileName;
          } else {
            this.$store.state.isLoading = false;
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
  },
  created() {
    this.getTimezones();
    if (this.tokenObj.UserType == this.userTypeMainAdmin) this.getSchools();
    if (this.$route.params.id) {
      this.getClassBookingDetail();
    } else if (this.$store.state.class.classId) {
      //check if redirected from Add Class Booking from Class List page
      let classId = this.$store.state.class.classId;
      let param = {
        Token: this.tokenObj.Token,
        Id: classId,
      };
      API.class
        .getClassDetail(param)
        .then((response) => {
          if (response.data.success) {
            if (this.isInstructorPage) {
              this.instructorId = this.tokenObj.Id;
              this.bookingDateTimes[0].instructorId = this.instructorId;
              this.bookingDateTimes[0].instructorName = this.tokenObj.Name;
            } else if (this.$store.state.class.instructorId) {
              this.bookingDateTimes[0].instructorId =
                this.$store.state.class.instructorId;
              this.bookingDateTimes[0].instructorName =
                this.$store.state.class.instructorName;
            }
            let data = response.data.data;
            this.schoolId = data.SchoolId;
            this.getSchoolStudents(data.SchoolId);
            this.subjectId = data.SubjectId;
            this.getSubjectsForClass(data.SchoolId, this.instructorId);
            this.subjectLevelId = data.SubjectLevelId;
            this.getSubjectLevelsForClassBooking(
              data.SchoolId,
              data.SubjectId,
              this.instructorId
            );
            this.duration = data.Duration;
            this.getDurationsForClassBooking(
              data.SchoolId,
              data.SubjectId,
              data.SubjectLevelId,
              this.instructorId
            );
            this.getInstructorsForClassBooking(
              data.SchoolId,
              data.SubjectId,
              data.SubjectLevelId
            );
            //populate location
            this.location =
              data.Location == "Others" ? data.LocationOthers : data.Location;
            this.getLocationsForClassBooking(
              data.SchoolId,
              data.SubjectId,
              data.SubjectLevelId,
              data.DurationHour,
              data.DurationMinute,
              this.instructorId
            );
            //populate booking datetimes
            this.bookingDateTimes[0].classId = classId;
            if (this.$store.state.class.date) {
              this.bookingDateTimes[0].bookingDate =
                this.$store.state.class.date;
              this.bookingDateTimes[0].bookingDateDisplay =
                this.getBookingDateDisplay(this.$store.state.class.date);
              this.counter++;
            }
            if (this.$store.state.class.time) {
              this.bookingDateTimes[0].bookingTime =
                this.$store.state.class.time;
            } else {
              var timing = data.Timings[0];
              this.bookingDateTimes[0].bookingTime = `${timing.Hour}:${timing.Minute} ${timing.TimePart}`;
            }
            this.bookingDateTimes[0].timezoneId = data.TimezoneId;
            this.bookingDateTimes[0].timezoneName = data.TimezoneName;
            this.bookingDateTimes[0].currency = data.CurrencyShortForm;
            this.bookingDateTimes[0].feeAmount = data.Amount;
            this.bookingDateTimes[0].isInclusiveTax = data.IsInclusiveTax;
            this.bookingDateTimes[0].isSalesTaxRegistered =
              data.IsSalesTaxRegistered;
            this.bookingDateTimes[0].salesTaxName = data.SalesTaxName;
            this.bookingDateTimes[0].salesTaxPercentage =
              data.SalesTaxPercentage;
            //populate feeAmountDisplay
            const options = { style: "decimal", minimumFractionDigits: 2 };
            let feeAmount = parseFloat(data.Amount ? data.Amount : 0);
            if (data.IsSalesTaxRegistered) {
              if (data.IsInclusiveTax) {
                this.bookingDateTimes[0].feeAmountPaid = feeAmount;
                this.bookingDateTimes[0].feeAmountDisplay = `<b>Amount Due (inclusive of ${
                  data.SalesTaxName
                } at ${data.SalesTaxPercentage}%) = ${
                  data.CurrencyShortForm
                } ${feeAmount.toLocaleString("en-US", options)}</b>`;
              } else {
                let salesTaxPercentage = parseFloat(
                  data.SalesTaxPercentage ? data.SalesTaxPercentage : 0
                );
                let taxAmount = (salesTaxPercentage * feeAmount) / 100;
                let feeAmountAfterTax = feeAmount + taxAmount;
                this.bookingDateTimes[0].feeAmountPaid = feeAmountAfterTax;
                this.bookingDateTimes[0].feeAmountDisplay = `${
                  data.CurrencyShortForm
                } ${feeAmount.toLocaleString("en-US", options)} <br/> Add ${
                  data.SalesTaxName
                } at ${salesTaxPercentage}% = ${
                  data.CurrencyShortForm
                } ${taxAmount.toLocaleString(
                  "en-US",
                  options
                )} <br/> <b>Amount Due = ${
                  data.CurrencyShortForm
                } ${feeAmountAfterTax.toLocaleString("en-US", options)}</b>`;
              }
            } else {
              this.bookingDateTimes[0].feeAmountPaid = feeAmount;
              this.bookingDateTimes[0].feeAmountDisplay = `<b>Amount Due = ${
                data.CurrencyShortForm
              } ${feeAmount.toLocaleString("en-US", options)}</b>`;
            }
            this.getInfosForClassBooking(
              data.SchoolId,
              data.SubjectId,
              data.SubjectLevelId,
              data.DurationHour,
              data.DurationMinute,
              data.LocationId,
              data.LocationOthers,
              "",
              this.instructorId
            );
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      if (this.tokenObj.UserType != this.userTypeMainAdmin) {
        this.schoolId = this.tokenObj.SchoolId;
        this.getSchoolStudents(this.tokenObj.SchoolId);
        if (this.isInstructorPage) {
          this.instructorId = this.tokenObj.Id;
          this.bookingDateTimes[0].instructorId = this.instructorId;
          this.bookingDateTimes[0].instructorName = this.tokenObj.Name;
        }
        this.getSubjectsForClass(this.tokenObj.SchoolId, this.instructorId);
      }
    }
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
.table-responsive,
.table {
  margin-bottom: 0;
}
.no-col {
  width: 40px;
  vertical-align: middle;
}
.date-col {
  border-right: none;
}
.time-col {
  border-left: none;
}
.instructor-col {
  width: 23%;
}
.fee-col {
  width: 20%;
  word-wrap: break-word;
  white-space: normal;
}
.time-options {
  position: absolute;
  z-index: 20;
  left: -1000px;
}
.timeoptions-div label {
  cursor: pointer;
  min-width: 84px;
  height: 50px;
  border: 1px solid darkgray;
  vertical-align: middle;
  margin-right: 15px;
  margin-bottom: 15px;
  padding-left: 5px;
  padding-right: 5px;
}
.timezone {
  font-size: 8px;
}
.bg-grey {
  background-color: lightgrey;
}
.currency,
.fee-amount {
  font-size: 25px;
}
.total {
  font-size: 20px;
}
.btn-link {
  color: #007bff;
  text-align: left;
}

.desktop-show {
  display: block;
}
.mobile-show {
  display: none;
}
@media only screen and (max-width: 767.98px) {
  .w-xs-40 {
    width: 40% !important;
  }
  .w-xs-50 {
    width: 50% !important;
  }
  .desktop-show {
    display: none;
  }
  .mobile-show {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassBookingEdit.vue